import React, { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../requestMethods";

const ContactForm = () => {
  const initialValues = {
    name: "",
    number: "",
    email: "",
    country: "",
    message: "",
  };
  const [formValues, setFormValues] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value } = e.target; // take name and value from input in destructring
    setFormValues({ ...formValues, [name]: value });
    console.log(formValues);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let DataFrom = new FormData();
    DataFrom.append("name", formValues.name);
    DataFrom.append("number", formValues.number);
    DataFrom.append("number", formValues.email);
    DataFrom.append("number", formValues.country);
    DataFrom.append("number", formValues.message);

    const formDetails = { ...formValues };
    console.log(formDetails);
    const res = await axios.post(`${BASE_URL}contact`, formDetails);
    console.log(res.data);
  };

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    //name
    if (!/^[a-z A-Z0-9]+$/.test(values.name) || /^[ ]+$/.test(values.name)) {
      errors.fullname = "Name is not valid";
    }

    if (!values.name) {
      errors.fullname = "Name is Required";
    }

    //email
    if (!values.email) {
      errors.email = "Email is Required";
    }
    if (!regex.test(values.email) && values.email) {
      errors.email = "Email is not valid";
    }

    //message
    if (!values.reviewMessage) {
      errors.reviewMessage = "Message is Required";
    }
    return errors;
  };

  return (
    <>
      <div className="contact-form">
        <form>
          <div className="contact-form-data">
            <div className="contact-forms">
              <div className="from-tab">
                <div className="form-block-title mb-1">
                  <h3 className="contact-heading">contact us</h3>
                </div>
                <div className="input-groups mb-1">
                  <div className="input-field">
                    <label>
                      Name<span className="text-red">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formValues.name}
                      onChange={handleChange}
                      placeholder="Full Name"
                    />
                  </div>

                  <div className="input-field">
                    <label>Email</label>
                    <input
                      type="text"
                      name="email"
                      value={formValues.email}
                      onChange={handleChange}
                      placeholder="rohit892051182@gmail.com"
                    />
                  </div>
                </div>
                <div className="input-groups mb-1">
                  <div className="input-field">
                    <label>Mobile No.</label>
                    <input
                      type="text"
                      name="number"
                      value={formValues.number}
                      onChange={handleChange}
                      placeholder="8920511882"
                    />
                  </div>

                  <div className="input-field state">
                    <label>Select State</label>

                    <select
                      name="country"
                      id="state"
                      onChange={handleChange}
                      value={formValues.country}
                    >
                      <option value="0">Select State</option>
                      <option value="delhi">Delhi</option>
                      <option value="maharashtra">Maharashtra</option>
                      <option value="karnataka">karnatka</option>
                    </select>
                  </div>
                </div>
                <div className="input-groups mb-1">
                  <div className="input-field address">
                    <label>Message.</label>
                    <textarea
                      name="message"
                      value={formValues.message}
                      onChange={handleChange}
                      placeholder="message"
                      rows="3"
                    />
                  </div>
                </div>

                <div className="input-groups mb-1"></div>
              </div>
            </div>
            <div className="payment-method">
              <button type="submit" className="btn" onClick={handleSubmit}>
                Contact Us
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default ContactForm;
